import React, { Component } from "react";
import { bindActionCreators } from "redux";
import withRedux from "next-redux-wrapper";
import withReduxSaga from "next-redux-saga";
import Head from "next/head";
import PropTypes from "prop-types";
// import styled from "styled-components";
import Store from "store";
import { fetchTagVideos } from "store/posts/actions";
// import { Link } from "routes";
import NProgress from "components/NProgress";
// import Header from '../container/DefaultLayout/header';
// import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import NewsItem from "/components/News/NewsItem";
import { Router } from "routes";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import Axios from "/plugins/axios";
// import Footer from "/container/DefaultLayout/footer.js";
// import Headroom from "react-headroom";
// import BrandsSlider from '/components/brandsSlider';
// import TagManager from 'react-gtm-module'
import Hidden from '@material-ui/core/Hidden';
// import MobileNewsItem from "/components/Mobile/MobileNewsItem";
// import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
// import ThereIsNoArticle from "/components/thereIsNoArticle";
// import fontUniOrConvertZawgyi from '/utils/fontUniOrConvertZawgyi';
import ContentTitle from "/components/contentTitle";
import ThereIsNoItem from '/components/thereIsNoItem';
import DesktopVideoCards from "/components/Video/DesktopVideoCards";
import MobileVideoCards from "/components/Video/MobileVideoCards";
import SeoMeta from '/components/seoMeta';

// const tagManagerArgs = {
//   dataLayer: {}
// }

const styles = theme => ({
  root: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      overflow: 'hidden',
      // backgroundColor: theme.palette.background.paper,
  },
  img: {
      width: '100%',
      height: 250,
      objectFit: 'cover'
  },
  titleBar: {
      backgroundColor: 'transparent'
  },
  title: {
      backgroundColor: '#212121',
      padding: '4px 8px'
  },

  gridList: {
     height: 'auto'
  },
  divider: {
      width: '90%',
      height: 1.5,
      marginTop: 35,
      top: '20',
      border: 'none',
      backgroundColor: '#c1bcbc!important'
  },
  icon: {
      color: 'white',
  },
  button: {
      margin: '13px 0px 23px',
      paddingLeft: 25,
      letterSpacing: '1px'
  },
  layout: {
    marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('md')]: {
        width: 1000,
      },
      [theme.breakpoints.only('md')]: {
        width: 900,
      },
      [theme.breakpoints.only('sm')]: {
        width: 650
    },
  },
 
});

class TagVideos extends Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      newsItems: [],
      count: 1,
      next: this.props.links.next,
      url: this.props.url,
    };
    
  }  

  static getInitialProps({ query, asPath, store }) {
    const { tag } = query;
    const currentDateTime = new Date().toISOString();
    store.dispatch(fetchTagVideos(tag, currentDateTime));
    return { tag, asPath, currentDateTime };
  }

nextPage = (url) => {
    const nextPerPage = isMobile ? 6 : 8
    url = `/videos/tags/${this.props.url.query.tag}?exclude=body&published_date=${this.props.currentDateTime}&perPage=${nextPerPage}&${  url.split('?').length > 0 ? `&${  url.split('?')[1]}` : ''}`;
    this.setState({ 
        loading: true
     });
    Axios.get(url)
        .then(res => {
            res.data.data.map((value) => this.state.newsItems.push(value))
            this.setState({
                newsItems: this.state.newsItems,
                next: res.data.links.next,
                url: this.props.url,
                loading: false,
               })
        })
}
__nextBtn () {
    const {classes, uniReadable} = this.props;
    if(this.state.next != null) {
        return (
          <div style={{textAlign: 'center', marginTop: 10}}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => !this.state.loading ? this.nextPage(this.state.next) : null}
            >
              <span>
                {
                    uniReadable ? 'နောက်ထပ်':  'ေနာက္ထပ္'
                }
              </span>
              {this.state.loading ? 
                <div className="ld ld-ring ld-spin" style={{marginLeft: 5, marginRight: 5}} />
                    : 
                <div style={{display: 'inline-flex'}}>
                  <Icon>keyboard_arrow_down</Icon>
                </div> 
                 }
            </Button>
            
          </div>
        )
    }
}


render() {
    const { tagVideos, links, categories, classes, brands } = this.props;
    const { newsItems } =this.state;
    const tagName = `${this.props.url.query.tag}`
    return (
      <div>
        <Head>
          <title>{this.props.url.query.tag}</title>
        </Head>
        <SeoMeta 
            url={`${process.env.BACKEND_URL}${this.props.asPath}`} 
            type="article"
            title={this.props.url.query.tag}
            description={this.props.url.query.tag}
            image='https://duwun-data.sgp1.cdn.digitaloceanspaces.com/react-assets/image/duwun-news-logo.jpg'
          />        
        <NProgress />
        <Hidden only={['md', 'lg', 'xl']}>
            <div style={{padding: '20px 10px 10px'}}>
                <ContentTitle contentTitle={this.props.url.query.tag} color="#fff" />
            </div>
            {
                tagVideos.length === 0 ?
                <ThereIsNoItem thereIsNoItem="There is no video." /> :  
                <MobileVideoCards routeName="videoDetail" items={tagVideos} newsItems={newsItems.length > 0 ? newsItems: null} />

            }
             { links.next ?  this.__nextBtn() : null} 
        </Hidden>
        <Hidden smDown>
            <div className={classes.root}>
                <div className='layout'>
                    <ContentTitle contentTitle={this.props.url.query.tag} color="#fff" />
                    {
                        tagVideos.length === 0 ?
                        <ThereIsNoItem thereIsNoItem="There is no video." /> :  
                        <DesktopVideoCards routeName="videoDetail" items={tagVideos} newsItems={newsItems.length > 0 ? newsItems: null} />
                    }
                     { links.next ?  this.__nextBtn() : null} 
                </div>
            </div>
        </Hidden>              
      </div>
    );
}
    componentDidMount () {
        if(isBrowser) {
          this.secondPage =  this.state.next;
          window.addEventListener('scroll', this.handleScroll.bind(this, this));
        }
    }
    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(that, event) {
      if(window.pageYOffset > 200 && isBrowser && !this.pageTwoLoaded) {
        // console.log("window.pageYOffset > 200");
        if(that.secondPage != null) {
          that.nextPage(that.secondPage);
        }
        that.pageTwoLoaded = true;
      }
    }    
    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)
        if(previousProps.url.query.tag != this.props.url.query.tag) {
          if(isBrowser) {
            this.pageTwoLoaded = false;
          }   
        }
    }
}

TagVideos.propTypes = {
  classes: PropTypes.object.isRequired,
  tagVideos: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = state => ({
  tagVideos: state.posts.tagVideos.data,
  links: state.posts.tagVideos.links,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchTagVideos,
    },
    dispatch
  );

export default withRedux(Store, mapStateToProps, mapDispatchToProps)(
  withReduxSaga(withStyles(styles)(TagVideos))
);
